import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVideos } from "../../domain/usecases/getVideos";
import { OnNotificationAlert } from "../../domain/usecases/onNotificationAlert";
import InfoNotificationAlert from "../../domain/entities/InfoNotificationAlert";
import { notificationReceived } from "../../../match/presentation/store/MatchSlice";
import { setUpdateGetProfileConfig } from "../../../profile/presentation/store/OnboardingSlice";
import { onGetSubscriptionByUser } from "../../../subscriptions/presentation/store/SubscriptionsThunk";
import { ConnectSocketAdmin } from "../../domain/usecases/connectSocket";
import { AdminDisconnectSocket } from "../../domain/usecases/disconnectSocket";
import { onGetProfileConfig } from "../../../profile/presentation/store/OnboardingThunk";

export const onGetVideos = createAsyncThunk(
  "admin/videos",
  async (_, { extra }) => {
    const { getVideos } = extra as {
      getVideos: GetVideos;
    };
    const result = await getVideos.execute();
    return result;
  },
);

export const onNotificationAlert = createAsyncThunk(
  "admin/notification-alert",
  async (_, { extra, dispatch }) => {
    const { onNotificationAlert } = extra as {
      onNotificationAlert: OnNotificationAlert;
    };
    onNotificationAlert.execute((data: InfoNotificationAlert) => {
      dispatch(notificationReceived(data));
      // Refresh the latest account status for any admin alert so verify and
      // unverify changes appear without a manual refresh.
      dispatch(onGetProfileConfig());
      if (data.title === "You are now verified")
        dispatch(setUpdateGetProfileConfig("verified"));
      if (data.title === "Live face check required")
        dispatch(setUpdateGetProfileConfig("live_face_required"));
      if (data.title === "New Subscription")
        dispatch(onGetSubscriptionByUser());
    });
  },
);

export const onConnectSocketAdmin = createAsyncThunk(
  "admin/connect-socket",
  async (_, { extra }) => {
    const { connectSocketAdmin } = extra as {
      connectSocketAdmin: ConnectSocketAdmin;
    };
    await connectSocketAdmin.execute();
    return;
  },
);

export const onDisconnectSocketAdmin = createAsyncThunk(
  "admin/disconnect-socket",
  async (_, { extra }) => {
    const { disconnectSocketAdmin } = extra as {
      disconnectSocketAdmin: AdminDisconnectSocket;
    };
    await disconnectSocketAdmin.execute();
    return;
  },
);
